import React from 'react';
export function SkeletonRow({
  cols = 5
}: {
  cols?: number;
}) {
  return <tr className="animate-pulse" data-id="element-1133">
      {Array.from({
      length: cols
    }).map((_, i) => <td key={i} className="px-6 py-4 whitespace-nowrap" data-id="element-1134">
          <div className="h-4 bg-[#e5e5e5] rounded w-24" data-id="element-1135" />
        </td>)}
    </tr>;
}
export function SkeletonText({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`bg-[#e5e5e5] animate-pulse rounded ${className}`} data-id="element-1136" />;
}